import { getMetricsConfig } from '../config/metrics';
import { apiService } from './api';

class MetricsService {
  private config;
  private baseURL: string;

  constructor() {
    this.config = getMetricsConfig();
    this.baseURL = this.config.backendUrl;
  }

  // Get main dashboard data
  async getDashboard(range = '24h') {
    return apiService.get(`/monitoring/v2/dashboard?range=${range}`);
  }

  // Get specific metric categories
  async getSystemHealth() {
    return apiService.get(`/monitoring/v2/system`);
  }

  async getPerformance() {
    return apiService.get(`/monitoring/v2/performance`);
  }

  async getBusinessMetrics() {
    return apiService.get(`/monitoring/v2/business`);
  }

  async getAlerts() {
    return apiService.get(`/monitoring/v2/alerts`);
  }

  // Track metrics from frontend
  async trackUserExperience(data: Record<string, any>) {
    // Skip metrics tracking in development mode
    if (import.meta.env.DEV) {
      console.debug('Metrics tracking skipped in development mode');
      return null;
    }
    
    try {
      return await apiService.post(`/metrics/track-user-experience`, data, { isPublic: true });
    } catch (error) {
      // Gracefully handle missing endpoint or other errors
      console.debug('Metrics tracking failed - endpoint may not exist:', error);
      return null;
    }
  }

  async trackPageLoad(pageName: string, loadTime: number) {
    return this.trackUserExperience({
      avg_page_load_time_ms: loadTime,
      max_page_load_time_ms: loadTime,
      min_page_load_time_ms: loadTime,
      p95_page_load_time_ms: loadTime,
      booking_completion_rate_percentage: 0, // Will be calculated by backend
      user_satisfaction_score: 8.5, // Default score
      bounce_rate_percentage: 0, // Will be calculated by backend
      session_duration_avg_seconds: 0, // Will be calculated by backend
      pages_per_session_avg: 1,
      mobile_performance_score: 9.0,
      desktop_performance_score: 9.0,
      status: 'healthy',
      additional_data: {
        page_name: pageName,
        user_agent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      },
    });
  }
}

export default new MetricsService();